import React from 'react';
import '../style.css';

const ClientReview = () => {
  const reviews = [
    {
      id: 1,
      name: "Mani Dubey",
      rating: 5,
      comment: "Shree Balaji Travel ki service bhut hi perfect hai. On-call support behtareen tha — especially Prama ji ka special thanks, unhone har step par bahut help ki. Highly recommended!",
      date: "2 days ago",
      location: "Varanasi, UP",
      avatarColor: "#D4A017",
      vehicle: "26 Seater Tempo"
    },
    {
      id: 2,
      name: "Rahul Sharma",
      rating: 5,
      comment: "Excellent service! Driver was professional and car was very clean. Will definitely use again for my next trip to Varanasi.",
      date: "1 week ago",
      location: "Delhi",
      avatarColor: "#8B4513",
      vehicle: "Innova Crysta"
    },
    {
      id: 3,
      name: "Priya Singh",
      rating: 4,
      comment: "Very comfortable journey from airport to hotel. The driver arrived 10 minutes early. Good communication throughout.",
      date: "2 weeks ago",
      location: "Mumbai",
      avatarColor: "#D4A017",
      vehicle: "Swift Dzire"
    },
    {
      id: 4,
      name: "Amit Verma",
      rating: 5,
      comment: "Best taxi service in Varanasi! Used their tempo traveller for family trip - spacious, clean, and very reasonable rates.",
      date: "3 weeks ago",
      location: "Lucknow",
      avatarColor: "#8B4513",
      vehicle: "Force Urbania"
    },
    
  ];

  return (
    <section className="cr-four-section">
      <div className="cr-four-header">
        <div className="cr-four-title-box">
          <h2 className="cr-four-main-title">Client Reviews</h2>
          <p className="cr-four-subtitle">What Our Customers Say About Our Service</p>
        </div>
        <div className="cr-four-stats-box">
          <div className="cr-four-rating-box">
            <div className="cr-four-average">4.9</div>
            <div className="cr-four-stars">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="cr-four-star">★</span>
              ))}
            </div>
            <div className="cr-four-total">Based on 250+ reviews</div>
          </div>
        </div>
      </div>

      <div className="cr-four-grid">
        {reviews.map((review) => (
          <div key={review.id} className="cr-four-card">
            <div className="cr-four-card-top">
              <div 
                className="cr-four-avatar" 
                style={{ backgroundColor: review.avatarColor }}
              >
                {review.name.charAt(0)}
              </div>
              <div className="cr-four-info">
                <h3 className="cr-four-name">{review.name}</h3>
                <div className="cr-four-meta">
                  <span className="cr-four-date">{review.date}</span>
                  <span className="cr-four-location">{review.location}</span>
                </div>
                <div className="cr-four-vehicle">{review.vehicle}</div>
              </div>
            </div>

            <div className="cr-four-rating">
              {[...Array(5)].map((_, i) => (
                <span 
                  key={i} 
                  className={`cr-four-rating-star ${i < review.rating ? 'cr-four-filled' : 'cr-four-empty'}`}
                >
                  ★
                </span>
              ))}
            </div>

            <p className="cr-four-comment">"{review.comment}"</p>

            <div className="cr-four-actions">
              <button className="cr-four-like-btn">
                <span className="cr-four-like-icon">👍</span>
                Helpful
              </button>
              <button className="cr-four-share-btn">
                <span className="cr-four-share-icon">↪</span>
                Share
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="cr-four-buttons">
        <button className="cr-four-write-btn">
          Write a Review
        </button>
        <button className="cr-four-view-btn">
          View All Reviews →
        </button>
      </div>

     
    </section>
  );
};

export default ClientReview;